
import { create } from 'zustand';

export const useVendorsStore = create((set) => ({
  // Data
  vendors: [],
  vendorsForDropdown: [],
  loading: false,
  error: null,
  success: null,

  // Pagination
  paginationData: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  },

  // Search & Filter
  searchParams: {
    searchTerm: '',
    sortBy: 'createdAt',
    sortDirection: 'desc'
  },
  columnFilters: {},
  uniqueValues: {},

  // UI State
  isFormOpen: false,
  isEditMode: false,
  deleteDialogOpen: false,
  isDetailViewOpen: false,
  selectedVendor: null,
  vendorToDelete: null,

  // Actions - Data
  setVendors: (vendors) => set({ vendors }),
  setVendorsForDropdown: (vendors) => set({ vendorsForDropdown: vendors }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setSuccess: (success) => set({ success }),
  setPaginationData: (paginationData) => set({ paginationData }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  // Actions - Search & Filter
  setSearchParams: (params) => set((state) => ({
    searchParams: { ...state.searchParams, ...params }
  })),
  setColumnFilters: (filters) => set({ columnFilters: filters }),

  // Actions - UI
  openAddForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedVendor: null,
    error: null,
    success: null
  }),

  openEditForm: (vendor) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedVendor: vendor,
    error: null,
    success: null
  }),

  closeForm: () => set({
    isFormOpen: false,
    selectedVendor: null,
    error: null,
    success: null
  }),

  openDeleteDialog: (vendor) => set({
    deleteDialogOpen: true,
    vendorToDelete: vendor
  }),

  closeDeleteDialog: () => set({
    deleteDialogOpen: false,
    vendorToDelete: null
  }),

  openDetailView: (vendor) => set({
    isDetailViewOpen: true,
    selectedVendor: vendor
  }),

  closeDetailView: () => set({
    isDetailViewOpen: false,
    selectedVendor: null
  }),

  clearError: () => set({ error: null }),
  clearSuccess: () => set({ success: null }),
  clearMessages: () => set({ error: null, success: null }),
}));

export default useVendorsStore;
